import React from 'react';
import { connect } from 'react-redux';
import { getDateMDYY } from '_helpers';
import { PatientCareCenterNoteSection } from '../Section';
import styles from './Common.module.css'

class PatientCareCenterNotePlanFoto extends React.Component {

    render() {
        if (this.props.survey) {
            return (
                <PatientCareCenterNoteSection id='plan_foto' name='FOTO Predictions' level={2}>
                    <span className={styles.row}>
                        <span className={styles.col1}>{'Score as of ' + getDateMDYY(this.props.survey.date) + ':'}</span>
                        <span className={styles.col2}>{this.props.survey.score}</span>
                    </span>
                    <span className={styles.row}>
                        <span className={styles.col1}>Predicted Discharge Score:</span>
                        <span className={styles.col2}>{this.props.survey.goal}</span>
                    </span>
                    <span className={styles.row}>
                        <span className={styles.col1}>Visits:</span>
                        <span className={styles.col2}>{this.props.survey.visits}</span>
                    </span>
                    <span className={styles.row}>
                        <span className={styles.col1}>Days:</span>
                        <span className={styles.col2}>{this.props.survey.days}</span>
                    </span>
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            );
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let surveyKeys = Object.keys(state.entities.fotoSurveys)
        .filter(key => state.entities.fotoSurveys[key].epno === epno)
        .sort((a, b) => new Date(state.entities.fotoSurveys[b].date).getTime() - new Date(state.entities.fotoSurveys[a].date).getTime());
    let survey = surveyKeys && surveyKeys.length > 0 ? state.entities.fotoSurveys[surveyKeys[0]] : undefined;

    return {
        noteId,
        epno,
        isWc: state.entities.admissions[epno].isWc,
        survey,
    };
}

const connectedPatientCareCenterNotePlanFoto = connect(mapStateToProps)(PatientCareCenterNotePlanFoto);
export { connectedPatientCareCenterNotePlanFoto as PatientCareCenterNotePlanFoto };

